import { render } from "./RotasRapidas.vue?vue&type=template&id=a1be5478&ts=true"
import script from "./RotasRapidas.vue?vue&type=script&lang=ts"
export * from "./RotasRapidas.vue?vue&type=script&lang=ts"

import "./RotasRapidas.vue?vue&type=style&index=0&id=a1be5478&lang=css"

import exportComponent from "F:\\Projetos 2024\\e-logDash\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__